import type { PickListOption } from './picklistOption';

export const FIELD_ASSOCIATION_MODES = {
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
} as const;

type FieldAssociationMode = (typeof FIELD_ASSOCIATION_MODES)[keyof typeof FIELD_ASSOCIATION_MODES];

export const CUSTOM_FIELD_TYPES = [
  'CHECKBOX',
  'CURRENCY',
  'DATE',
  'ITEM',
  'LINK',
  'MULTI_CUSTOMER',
  'MULTI_ITEM',
  'MULTI_LINK',
  'MULTI_PICKLIST',
  'MULTI_TEXT',
  'MULTI_USER',
  'MULTILINE_TEXT',
  'NOTE',
  'NUMERIC',
  'PICKLIST',
  'TEXT',
  'USER',
] as const;

export type CustomFieldTypes = (typeof CUSTOM_FIELD_TYPES)[number];

const MULTI_VALUE_FIELD_TYPES = new Set<CustomFieldTypes>([
  'MULTI_CUSTOMER',
  'MULTI_ITEM',
  'MULTI_LINK',
  'MULTI_PICKLIST',
  'MULTI_TEXT',
  'MULTI_USER',
]);

export const isMultiValueCustomFieldType = (fieldType: CustomFieldTypes): boolean =>
  MULTI_VALUE_FIELD_TYPES.has(fieldType);

const DIALOG_EDITED_SINGLE_VALUE_FIELD_TYPES = new Set<CustomFieldTypes>([
  'LINK',
  'USER',
  'ITEM',
  'MULTILINE_TEXT',
  'NOTE',
]);

export const isDialogEditedCustomFieldType = (fieldType: CustomFieldTypes): boolean =>
  isMultiValueCustomFieldType(fieldType) || DIALOG_EDITED_SINGLE_VALUE_FIELD_TYPES.has(fieldType);

interface UpsertPicklistOption {
  id?: number | null;
  name: string;
  color: string;
  archived: boolean;
}
export interface CustomField {
  id: number;
  type: CustomFieldTypes;
  name: string;
  currencyUnit: string | null;
  picklistOptions: PickListOption[] | null;
  priority: string;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
  itemTypeAssociationMode: FieldAssociationMode;
  readonly: boolean;
  associatedItemTypeIds: number[] | null;
}

export type CreateCustomField = {
  name: string;
  type: CustomFieldTypes;
  currencyUnit?: string | null;
  archived?: boolean;
  picklistOptions?: UpsertPicklistOption[] | null;
  beforeId?: number | null;
  afterId?: number | null;
  itemTypeAssociationMode?: FieldAssociationMode;
};

export type UpdateCustomField = Partial<Omit<CreateCustomField, 'type'>>;
